import * as React from 'react';
import clsx from 'clsx';
import { Link } from 'gatsby';
import styles from './subnav.module.css';
import { Topic } from '../Types';
import { useLocation } from '@reach/router';
import smoothscroll from 'smoothscroll-polyfill';

import SearchIcon from './search.inline.svg';

const Routes = require('../../routes').Routes;

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

interface Props {
  topics: ReadonlyArray<Topic>;
}

function SubNavigation({ topics }: Props) {
  const ulRef = React.useRef<HTMLUListElement | null>(null);
  const activeLink = React.useRef<HTMLAnchorElement | null>(null);
  const location = useLocation();

  const scrollToActiveLink = React.useCallback((el: HTMLAnchorElement) => {
    if (el?.classList.contains(styles.active)) {
      activeLink.current = el;
    }
  }, []);

  const list = React.useMemo(
    () => topics.slice().sort((a, b) => a.id.localeCompare(b.id)),
    [topics]
  );

  React.useEffect(() => {
    if (activeLink.current && ulRef.current) {
      const { top, left } = activeLink.current?.getBoundingClientRect();

      ulRef?.current.scrollTo({
        left: left - 20,
        top,
        behavior: 'smooth',
      });
    }
  }, [ulRef, activeLink]);

  return (
    <nav className={styles.blogNavigation}>
      <div className={styles.container}>
        <ul className={clsx(styles.list)} ref={ulRef}>
          <li className={styles.item} key="all">
            <Link
              to={Routes.BLOG_ALL}
              className={clsx(styles.link, { [styles.active]: location.pathname === Routes.BLOG })}
              activeClassName={styles.active}
              innerRef={scrollToActiveLink}
            >
              All
            </Link>
          </li>
          {list.map((e) => (
            <li className={styles.item} key={e.id}>
              <Link
                to={Routes.BLOG + e.slug + '/'}
                className={styles.link}
                activeClassName={styles.active}
                innerRef={scrollToActiveLink}
              >
                {e.title}
              </Link>
            </li>
          ))}
        </ul>

        <div className={styles.search}>
          <Link to={Routes.BLOG + 'search/'} activeClassName={styles.activeSearchLink}>
            <SearchIcon className={styles.searchLinkIcon} />
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default SubNavigation;
